export default "__VITE_ASSET__BP9BScvs__"